import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { openHandlingModal } from 'redux/modules/journey-handling/effects';

import { Link, Spacer } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
import Name from './Name';

const enhance = compose(
  connect(null, {
    openHandlingModal,
  }),
  withHandlers({
    onEditClick:
      ({ id, handledBy, openHandlingModal }) =>
      (e) => {
        e.stopPropagation();
        openHandlingModal({ id, handledBy });
      },
  })
);

const IsHandledBy = ({
  showEditIcon,
  allowEdit,
  handledBy,
  onEditClick,
  skin = 'primary',
  intl,
}) => {
  const t = intl.messages.modules.journey.detail.journey_info;
  const editable = allowEdit;
  const hasOwner = !!handledBy;

  if (!editable) {
    return (
      <Spacer mLeft="XS">{hasOwner ? <Name name={handledBy.name} /> : <Name name={t.no} />}</Spacer>
    );
  }

  return (
    <Spacer mLeft="XS">
      <Link
        iconPosition={showEditIcon && 'left'}
        icon={showEditIcon && 'edit'}
        text={
          <Fragment>
            &nbsp;
            <Name name={hasOwner ? handledBy.name : t.no_owner} />
          </Fragment>
        }
        skin={skin}
        weight="bold"
        onClick={onEditClick}
      />
    </Spacer>
  );
};

IsHandledBy.propTypes = {
  handledBy: PropTypes.object,
  onEditClick: PropTypes.func,
  allowEdit: PropTypes.bool,
  showEditIcon: PropTypes.bool,
};

IsHandledBy.defaultProps = {
  allowEdit: true,
  showEditIcon: false,
};

export default enhance(injectIntl(IsHandledBy));
